import { render } from "./DeleteAssetLink.vue?vue&type=template&id=ba1e3874"
import script from "./DeleteAssetLink.vue?vue&type=script&lang=js"
export * from "./DeleteAssetLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__